import { useTooltipTrigger as useTooltipTrigger$1 } from 'react-aria';
import { useTooltipTriggerState } from 'react-stately';

/**
 * Hook for building an accessible tooltip.
 *
 * @param options - Options for the hook.
 * @param ref - A ref to the underlying HTML element.
 */ function useTooltipTrigger(options, ref) {
    const { closeDelay = 150, delay = 300, disabled = false, onlyOnFocus = false, open } = options;
    const tooltipTriggerProps = {
        ...options,
        closeDelay,
        delay,
        isDisabled: disabled,
        isOpen: open,
        trigger: onlyOnFocus ? 'focus' : undefined
    };
    const state = useTooltipTriggerState(tooltipTriggerProps);
    const { triggerProps, tooltipProps } = useTooltipTrigger$1(tooltipTriggerProps, state, ref);
    return [
        state,
        {
            triggerProps,
            tooltipProps
        }
    ];
}

export { useTooltipTrigger };
//# sourceMappingURL=use-tooltip-trigger.js.map
